export const SET_METER_LIST = "SET_METER_LIST"
export const SET_SPV_LIST = "SET_SPV_LIST"
export const SET_GA_LIST = "SET_GA_LIST"
export const SET_CHARGEAREA_LIST = "SET_CHARGEAREA_LIST"
export const SET_PR0JECT_LIST = "SET_PR0JECT_LIST"
export const SET_RESPONSE_DATA = "SET_RESPONSE_DATA"
export const FETCH_METER_LIST = "FETCH_METER_LIST"

export const setMeterList = (payload) => async (dispatch) => {
  // console.log(payload, 'meter list')
  dispatch({
    type: SET_METER_LIST,
    payload

  })
}

export const setSPVList = (payload) => async (dispatch) => {
  // console.log(payload, 'meter list')
  dispatch({
    type: SET_SPV_LIST,
    payload

  })
}

export const setGAList = (payload) => async (dispatch) => {
  // console.log(payload, 'meter list')
  dispatch({
    type: SET_GA_LIST,
    payload

  })
}

export const setChargeAreaList = (payload) => async (dispatch) => {
  // console.log(payload, 'meter list')
  dispatch({
    type: SET_CHARGEAREA_LIST,
    payload

  })
}

export const FromMeterlistProjectData = (payload) => async (dispatch) => {
  // console.log(payload, 'meter list')
  dispatch({
    type: SET_RESPONSE_DATA,
    payload

  })
}

export const setProjectList = (payload) => async (dispatch) => {
  // console.log(payload, 'meter list')
  dispatch({
    type: SET_PR0JECT_LIST,
    payload

  })
}


export const setShouldFetchMeterList = (payload) => async (dispatch) => {
  // console.log(payload, 'meter list')
  dispatch({
    type: FETCH_METER_LIST,
    payload

  })
}